import axios from 'axios'
import { The } from 'helpers/generalHelpers'
import { HTTP } from 'types'
import { APIURL, config, getCurrentWorkspace } from './_utils'

const workspace = getCurrentWorkspace()

// #region FORM ROW TAGS

export const responseTags = {
  create: (formSlug, formData) =>
    The(
      axios.post(
        `${APIURL}/v4/forms/${formSlug}/row-tags/`,
        formData,
        config({
          contentType: HTTP.ContentTypes.JSON,
          workspace,
        })
      )
    ),
  get: (formSlug, tagSlug) =>
    The(
      axios.get(
        `${APIURL}/v4/forms/${formSlug}/row-tags/${tagSlug}/`,
        config({ workspace })
      )
    ),

  getAll: (formSlug, params) =>
    The(
      axios.get(
        `${APIURL}/v4/forms/${formSlug}/row-tags/`,
        config({ params, workspace })
      )
    ),

  update: (formSlug, rowTagSlug, formData) =>
    The(
      axios.patch(
        `${APIURL}/v4/forms/${formSlug}/row-tags/${rowTagSlug}/`,
        formData,
        config({
          contentType: HTTP.ContentTypes.JSON,
          workspace,
        })
      )
    ),

  delete: (formSlug, rowTagSlug) =>
    The(
      axios.delete(
        `${APIURL}/v4/forms/${formSlug}/row-tags/${rowTagSlug}/ `,
        config({
          contentType: HTTP.ContentTypes.JSON,
          workspace,
        })
      )
    ),
}

// #endregion FORM ROW TAGS
